import { passingModeStep, passingModeType } from '@/types';

export const passingModeTypeLabels: Record<passingModeType, string> = {
  [passingModeType.INTERNATIONAL]: 'International',
  [passingModeType.NATIONAL]: 'National',
};

export const passingModeStepLabels: Record<passingModeStep, string> = {
  [passingModeStep.ETAPE_UNIQUE]: 'Étape unique',
  [passingModeStep.DEUX_ETAPES]: 'Deux étapes',
};
